import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

type ModalData = { title: string; content: string };
export const useVasRatePlanModalControls = () => useBrowserModalControls<ModalData>('sap-rate-plan-vas-modal');
